import React, { Component } from "react";
import { directoryUrl } from "settings";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Button = props => {
  const { title, icon, url, color } = props;

  return (
    <a href={url} target="_blank">
      <div className="directory__view-Button">
        <div
          className="directory__view-Button-circle"
          style={{ background: color }}
        >
          <div className="directory__view-Button-circle-iconWrapper">
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div className="directory__view-Button-title">
          <h1>{title}</h1>
        </div>
      </div>
    </a>
  );
};

const onLoad = () => {
  document.body.classList.add("no-scroll");
};

export default class DirectoryView extends Component {
  componentWillUnmount() {
    document.body.classList.remove("no-scroll");
  }

  render() {
    return (
      <div className="directory__view">
        {/* <iframe
          title={`${directoryUrl}?${Date.now()}`}
          src={directoryUrl}
          onLoad={onLoad}
        /> */}

        <div className="directory__view-ButtonContainer">
          <Button
            title="Accommodations"
            url="https://www.visitwales.com/search?search=Accommodation"
            icon={["fas", "bed"]}
            color="#e30613"
          />

          <Button
            title="Attractions"
            url="https://www.visitwales.com/search?search=Attractions"
            icon={["fas", "landmark"]}
            color="#e30613"
          />
          <Button
            title="Activities"
            url="https://www.visitwales.com/search?search=Activities"
            icon={["fas", "hiking"]}
            color="#e30613"
          />
          <Button
            title="Events"
            url="https://www.visitwales.com/search?search=Events"
            icon={["fas", "flag-checkered"]}
            color="#e30613"
          />
        </div>
      </div>
    );
  }
}
